module.exports = __webpack_public_path__ + "img/honorListImg2.4f1e56a9.jpg";